/* Pension Credit calculator. Figures and rules: brief.md (approved spec v7, checked 12 Oct 2026).
   Runs in memory only. No network, storage, or cookies. */
(function (root, factory) {
  var api = factory();
  if (typeof module === "object" && module.exports) module.exports = api;
  else root.KTPensionCredit = api;
})(typeof globalThis !== "undefined" ? globalThis : this, function () {
  var RATES = {
    checked: "2026-10-12",
    smgSinglePence: 23800,
    smgCouplePence: 36325,
    sdaPence: 8605,
    sdaCoupleBothPence: 17210,
    carerPence: 4815,
    savingsCreditSinglePence: 1796,
    savingsCreditCouplePence: 2010,
    savingsIgnorePence: 1000000,
    tariffStepPence: 50000,
    closeBandPence: 1000
  };

  function parsePoundsToPence(raw) {
    var s = String(raw == null ? "" : raw).trim().replace(/£/g, "").replace(/,/g, "");
    if (s === "") return 0;
    if (!/^\d+(\.\d{1,2})?$/.test(s)) return null;
    var parts = s.split(".");
    var pounds = parseInt(parts[0], 10);
    var pence = 0;
    if (parts[1]) pence = parseInt(parts[1].length === 1 ? parts[1] + "0" : parts[1], 10);
    return pounds * 100 + pence;
  }

  /* Monthly amount × 12 ÷ 52, to the nearest penny. That penny is what we add up. */
  function weeklyFromMonthlyPence(monthlyPence) {
    return Math.round(monthlyPence * 12 / 52);
  }

  function tariffPence(savingsPence) {
    if (savingsPence <= RATES.savingsIgnorePence) return 0;
    var steps = Math.ceil((savingsPence - RATES.savingsIgnorePence) / RATES.tariffStepPence);
    return steps * 100;
  }

  function roundTo5p(pence) {
    return Math.round(pence / 5) * 5;
  }

  function ageOutcome(state) {
    if (!state.couple && state.personSpa === false) return "not_yet";
    if (state.couple && state.personSpa === false && state.partnerSpa === false) return "not_yet";
    if (state.couple && (state.personSpa === false || state.partnerSpa === false)) {
      if (state.housingBenefit === true) return "continue";
      return "mixed_age";
    }
    if (state.personSpa === true && (!state.couple || state.partnerSpa === true)) return "continue";
    return "incomplete";
  }

  function isRouteOut(state) {
    return !!(state.selfEmployed || state.otherProperty || state.deferring || state.careHome || state.abroad || state.child || state.euUnsure);
  }

  function sdaPence(state) {
    var me = !!state.qbMe;
    var partner = !!state.qbPartner;
    var carerMe = !!state.carerPaidMe;
    var carerPartner = !!state.carerPaidPartner;
    if (!state.couple) {
      if (me && state.livesAlone && !carerMe) return RATES.sdaPence;
      return 0;
    }
    if (!state.noOneElse) return 0;
    if (me && partner) {
      if (!carerMe && !carerPartner) return RATES.sdaCoupleBothPence;
      if (carerMe !== carerPartner) return RATES.sdaPence;
      return 0;
    }
    if (me !== partner) {
      var carerForQualifying = me ? carerMe : carerPartner;
      if (!carerForQualifying && state.blindOther) return RATES.sdaPence;
    }
    return 0;
  }

  function calculate(state) {
    if (isRouteOut(state)) return { outcome: "route_out", flags: [] };
    var sda = sdaPence(state);
    var threshold = state.couple ? RATES.smgCouplePence : RATES.smgSinglePence;
    if (sda > 0) threshold += sda;
    var carers = 0;
    if (state.carerMe) carers += 1;
    if (state.couple && state.carerPartner) carers += 1;
    threshold += carers * RATES.carerPence;
    var tariff = tariffPence(state.savingsPence);
    var counted = state.incomePence + tariff;
    var gc = Math.max(0, threshold - counted);
    var outcome = "unlikely";
    if (gc > 0) outcome = "estimate";
    else if (counted - threshold <= RATES.closeBandPence) outcome = "close";
    var flags = [];
    if (state.housingCosts) flags.push("housing");
    if (state.savingsCreditFlag) flags.push("savings_credit");
    if (sda > 0) flags.push("sda");
    if ((state.qbMe || (state.couple && state.qbPartner)) && sda === 0) flags.push("disability_check");
    var shown = outcome === "estimate" ? roundTo5p(gc) : 0;
    return {
      outcome: outcome,
      gcPence: gc,
      displayWeeklyPence: shown,
      displayAnnualPence: shown * 52,
      thresholdPence: threshold,
      tariffPence: tariff,
      countedPence: counted,
      sdaPence: sda,
      flags: flags
    };
  }

  return {
    RATES: RATES,
    parsePoundsToPence: parsePoundsToPence,
    weeklyFromMonthlyPence: weeklyFromMonthlyPence,
    tariffPence: tariffPence,
    roundTo5p: roundTo5p,
    ageOutcome: ageOutcome,
    calculate: calculate
  };
});
